
export const setTopics = (state, topics) => {
    state.topics = topics
    state.loading = false
}

export const setCurrentTopic = (state, topic) => {
    state.currentTopic = topic
    state.loading = false
}

export const setLoading = (state, loading) => {
    state.loading = loading
}
